import { Sidebar } from 'primereact/sidebar';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { subscriberLogout } from '../../slices/subscriberAuthSlice';
import styles from './SubscriberMenu.module.css';

export default function SubscriberMenu({
  visible,
  onHide,
  loginPath,
  myGroupsPath,
  subscriptionsPath,
  settingsPath,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleLogout() {
    dispatch(subscriberLogout());
    onHide();
    navigate(loginPath, { replace: true });
  }

  return (
    <Sidebar visible={visible} onHide={onHide} position="right" className={styles.sidebar}>
      <nav className={styles.nav}>
        <Link to={myGroupsPath} className={styles.navItem} onClick={onHide}>
          <i className="pi pi-th-large" />
          My Groups
        </Link>
        <Link to={subscriptionsPath} className={styles.navItem} onClick={onHide}>
          <i className="pi pi-list" />
          Subscriptions
        </Link>
        <Link to={settingsPath} className={styles.navItem} onClick={onHide}>
          <i className="pi pi-cog" />
          Settings
        </Link>
        <button type="button" className={styles.navItem} onClick={handleLogout}>
          <i className="pi pi-sign-out" />
          Log out
        </button>
      </nav>
    </Sidebar>
  );
}
